import { Checkbox } from '@cluey/cluey-components';
import { CancelReason } from '../../../../../../types/hubInterfaces';

interface Props {
  checked: boolean;
  onCheck(reason: CancelReason): void;
  reason: CancelReason;
  additionalInfo?: React.ReactNode;
}

const ReasonCheckbox = ({ reason, checked, onCheck, additionalInfo }: Props) => {
  return (
    <>
      <div key={reason.label} className="flex items-center gap-x-3">
        <div className="shrink-0">
          <Checkbox id={reason.label} onChange={() => onCheck(reason)} value={checked} />
        </div>
        <div className="flex flex-col gap-y-1">
          <label className="cursor-pointer text-sm" htmlFor={reason.label}>
            {reason.label}
          </label>
        </div>
      </div>

      {additionalInfo && <div>{additionalInfo}</div>}
    </>
  );
};

export default ReasonCheckbox;
